export const config = {
  api: 'https://api.pairdot.com',
  urlServiceDomain: 'https://pdot.me',
  featureFlag: {
    encrypt: false,
  },
}
